import React from 'react';

interface FrameProps {
  content: string;
}

class Frame extends React.Component<FrameProps> {
  private iframeRef: React.RefObject<HTMLIFrameElement>;

  constructor(props: FrameProps) {
    super(props);
    this.iframeRef = React.createRef<HTMLIFrameElement>();
  }

  _updateHeight() {
    const iframe = this.iframeRef.current;
    const doc = iframe?.contentDocument;
    if (!iframe || !doc) return;

    iframe.style.height = doc.documentElement.scrollHeight + 'px';
  }

  render() {
    return (
      <iframe
        ref={this.iframeRef}
        sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
        srcDoc={`<base target="_blank">${this.props.content}`}
        scrolling="no"
        style={{ width: '100%' }}
        onLoad={this._updateHeight.bind(this)}
      />
    );
  }
}

export default Frame;
